import { render, staticRenderFns } from "./SetSchoolModal.vue?vue&type=template&id=4260f959&"
import script from "./SetSchoolModal.vue?vue&type=script&lang=js&"
export * from "./SetSchoolModal.vue?vue&type=script&lang=js&"
import style0 from "./SetSchoolModal.vue?vue&type=style&index=0&id=4260f959&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports